
// WebpackRequireFrom
typeof __webpack_require__ !== "undefined" && Object.defineProperty(__webpack_require__, "p", {
  get: function () {
try {
  if (typeof marketplaceFrontendUrl !== "string") {
    throw new Error("WebpackRequireFrom: 'marketplaceFrontendUrl' is not a string or not available at runtime. See https://github.com/agoldis/webpack-require-from#troubleshooting");
  }
  return marketplaceFrontendUrl;
} catch (e) {
  if (!false) {
    console.error(e);
  }
  return "/mf-static/";
}
 },
  set: function (newPublicPath) {
    console.warn("WebpackRequireFrom: something is trying to override webpack public path. Ignoring the new value" + newPublicPath  + ".");
}
});